module.exports = __webpack_public_path__ + "img/khalImg2.e40324bd.png";